
import React from 'react'
import xxhash from 'xxhashjs'
export { getStyleProperties } from './css'
import { applyCustomProperties, getClassname } from './css'
import * as box from './custom/box'
import * as hbox from './custom/hbox'
import * as vbox from './custom/vbox'

// TODO: refactor so that getStyleProperties is used here:
//  - combine custom props and existing ones
//  - pass those to getStyleProperties() and getClassname()
//  - curry getStyleProperties?

/**
 * Export Box as the default.
 */

export default Box

/**
 * Box is a layout component primitive.
 */

export function Box({ is = 'div', innerRef, children, className = '', ...props }) {
  props = applyCustomProperties(props, box)
  const { className: classname, ...rest } = getClassname(props, hash)
  return React.createElement(is, {
    ref: innerRef,
    className: `${classname} ${className}`,
    ...rest
  }, children)
}
 
/**
 * HBox is layout component rendering items along the x-axis.
 */

export function HBox({ gap, children, ...props }) {
  if (gap) {
    children = applyGap(gap, children, 'marginRight')
  }

  return <Box
    display="flex"
    minWidth={0}
    minHeight={0}
    {...applyCustomProperties(props, hbox)}
  >
    {children}
  </Box>
}

/**
 * VBox is layout component rendering items along the y-axis.
 */

export function VBox({ gap, children, ...props }) {
  if (gap) {
    children = applyGap(gap, children, 'marginBottom')
  }

  return <Box
    display="flex"
    flexDirection="column"
    minWidth={0}
    minHeight={0}
    {...applyCustomProperties(props, vbox)}
  >
    {children}
  </Box>
}

/**
 * applyGap returns children with a gap applied.
 */

function applyGap(gap, children, prop) {
  const len = children.length
  return React.Children.map(children, (c, i) => {
    return i == len - 1
      ? c
      : React.cloneElement(c, { [prop]: gap })
  })
}

/**
 * Hash implementation.
 */

function hash(s) {
  return xxhash.h32(s, 0xBADDCAFE).toString(16)
}